import PalletMark from "../../assets/images/pallet-icon-loader.png";
import "./PosActivityLoader.css";

function PosActivityLoader() {
  return (
    <div className="pos-activity-loader" role="status" aria-label="Loading" aria-live="polite">
      <span className="pos-activity-loader__art" aria-hidden="true">
        <span className="pos-activity-loader__orbit" />
        <img className="pos-activity-loader__mark" src={PalletMark} alt="" />
      </span>
      <span className="pos-activity-loader__label">Loading</span>
    </div>
  );
}

export default PosActivityLoader;
